import { atom } from 'jotai';

const holidayDonateModalAtom = atom<boolean>(false);
const holidayExtensionModalAtom = atom<boolean>(false);

export { holidayDonateModalAtom, holidayExtensionModalAtom };
